import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import MuiLink from "@mui/material/Link";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";
import MDButton from "common/components/MD/MDButton";

import LogoAgri2027 from "common/assets/images/logos/AU_banner_logo-negativo_farfiera.png"
import { brandButtonOutlinedSx } from "common/assets/theme/components/brandButtonSx";



function Banner_2027({ action }) {




  return (
    <Card>
      <MDBox position="relative" borderRadius="lg" mt={-3} mx={2}>
        <MDBox
          component="img"
          src={LogoAgri2027}
          alt="Agriumbria 2027"
          borderRadius="lg"
          shadow="md"
          width="100%"
          height="100%"
          position="relative"
          padding={0}
          zIndex={1}
        />
     
      </MDBox>
      <MDBox p={3}>
        <MDTypography display="inline" variant="h3" textTransform="capitalize" fontWeight="bold" sx={({ palette: { brand } }) => ({ color: brand.main })}>
        Agriumbria 2027
        </MDTypography>
        <MDBox mt={2} mb={3}>
          <MDTypography variant="body2" component="p" color="text">
          Benvenuto nella tua <b>Area Riservata</b>, all’interno della quale potrai gestire tutte le operazioni inerenti ad Agriumbria 2027. La <b>Proposta di Partecipazione </b>
          dovrà essere presentata entro il <b>30 novembre 2026</b> e sarà valutata dalla Commissione Tecnico-Commerciale.
          </MDTypography>
        </MDBox>
              <MDBox mt={2} mb={3} >    
      <Link to="https://far.umbriafiere.it/download/TARIFFE_2027.pdf" target="_blank">
    
         <MDButton variant="outlined"   sx={brandButtonOutlinedSx }  >
                                                           Settori Merceologici-Modalità Espositive-Tariffe
                                                        </MDButton>
                                                        
                                                        </Link>
                                                        </MDBox>
         {action.type === "external" ? (
          <MuiLink href={action.route} target="_blank" rel="noreferrer">
            <MDButton color={action.color ? action.color : "dark"}>{action.label}</MDButton>
          </MuiLink>
      
        ) : (action.type === "internal"?(
          <Link to={action.route}>
            <MDButton color={action.color ? action.color : "dark"}>{action.label}</MDButton>
          </Link>

        ):
      (
          <MDButton color={action.color ? action.color : "dark"} onClick={action.route} >{action.label} </MDButton>
      )
   )}
   

                                                        </MDBox>
    </Card>
  );
}

// Typechecking props for the SimpleBlogCard
Banner_2027.propTypes = {
   action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal"]).isRequired,
    route: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
      "default",
    ]),
    label: PropTypes.string.isRequired,
  }).isRequired,
};

export default Banner_2027;
